import { DatagridRow as RaDatagridRow, DatagridRowProps as RaDatagridRowProps } from 'react-admin';

export const DatagridRow = RaDatagridRow;

export type DatagridRowProps = RaDatagridRowProps;
